import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, EMPTY, map, Observable, shareReplay, switchMap } from "rxjs";
import { ReleaseTypeResource } from "../models/release-type-resource.model";
import { ReleaseTypesResource } from "../models/release-types-resource.model";

@Injectable({ providedIn: "root" })
export class ReleaseTypesService {
    private readonly httpClient = inject(HttpClient);
    private readonly refreshRequests = new BehaviorSubject<void>(undefined);

    private releaseTypes$ = this.refreshRequests.pipe(
        switchMap((_, index) => {
            const releaseTypes$ = this.httpClient.get<ReleaseTypesResource>("/api/releaseTypes");
            return index ? releaseTypes$.pipe(catchError(() => EMPTY)) : releaseTypes$;
        }),
        map((res) => res.releaseTypes ?? res.items ?? []),
        shareReplay(1)
    );

    public getReleaseTypes$(): Observable<Array<ReleaseTypeResource>> {
        return this.releaseTypes$;
    }

    public refresh(): void {
        this.refreshRequests.next();
    }
}
